<div class="tam-contact-control" attr.tid="{{config.controlName}}">
    <div>
        <kendo-dropdownlist [style.width.px]="childConfig.css.width" [popupSettings]="{appendTo: 'component'}"
            #dropDownEl [data]="suggestionItems" [filterable]="true" (filterChange)="handleFilter($event)"
            [disabled]="readOnly" [textField]="'name'" [valueField]="'id'" [(ngModel)]="selectedItem"
            (focus)="dropDownEl.toggle(true)" (valueChange)="valueChange($event)" (keydown.esc)="onEnter($event)"
            (mousedown)="$event.preventDefault()">
            <ng-template kendoMultiSelectHeaderTemplate>
                <div class="popup-template-clear-header">
                    <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                </div>
            </ng-template>
            <div *ngIf="config.controlID === 'Company'">
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <tam-entity-dropdown-item [entity]="dataItem">
                    </tam-entity-dropdown-item>
                </ng-template>

                <ng-template kendoDropDownListFooterTemplate>
                    <div *ngIf="searchItem" class="dropdown-fly-item" (click)="createEntity()">
                        <span>{{searchItem}} (New company)</span>
                    </div>
                </ng-template>
            </div>
        </kendo-dropdownlist>
    </div>
    <label [hidden]="hasPermissionToView" class="dis-row">Company field contains a private entity that you have no
        permission to view</label>
    <label [hidden]="!showCompanyError" class="dis-row"> Entity <span>{{hintContent}}</span> not found, please<label
            class="hint-click" (click)="clickContactFly()"> create </label> or enter a new one
    </label>
    <label [hidden]="!hintContent ||showCompanyError" class="item-label-error">
        {{hintContent}}
    </label>
</div>